
abstract class AbstractValue<Raw> {
  constructor(protected readonly raw: Raw) { }
}

export default AbstractValue
